// extracted by mini-css-extract-plugin
export var articleGrid = "ArticlesListBlock-module--articleGrid--9ad57";
export var btn = "ArticlesListBlock-module--btn--4b753";